"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

var _AntdIcon = _interopRequireDefault(require("../../antdIcon/AntdIcon"));

require("./fieldErrorMessage.scss");

const FieldErrorMessage = props => {
  const {
    isVisible,
    message
  } = props;

  if (!isVisible) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hmp-field-error-message"
  }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
    fontAwesomeIcon: _proSolidSvgIcons.faExclamationCircle
  }), ' ', message);
};

var _default = FieldErrorMessage;
exports.default = _default;